var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateJets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#221f1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.3 68.8C116.6 63 104.3 52 91.9 52c-7 0-12.9.5-18.8 1.1l-14.3-6c-.3 0-.5-.1-.8-.1H40.1c-.8 0-1.4.4-1.8 1.1-.3.7-.3 1.5.2 2.1l4 5.6c-3.7.1-7.8.2-12.4.2-1.8-.2-7-7.2-11.2-15-.4-.6-1-1-1.8-1h-9c-.6 0-1.2.3-1.5.7-.4.5-.5 1.1-.4 1.7L12 70.6l-5.5 8.3c-.4.6-.4 1.4-.1 2s1 1.1 1.8 1.1h11c.4 0 .8-.1 1.1-.3l4.2-2.7h8l-13.3 8.3c-.8.5-1.1 1.4-.9 2.2.2.9 1 1.5 1.9 1.5h17.9c.3 0 .5 0 .7-.1L69 79h34.8c7.3 0 12.4-1 16-3.3 1.2-.7 2.1-2.1 2.3-3.5.3-1.3 0-2.5-.8-3.4zM57.6 51l7.3 3c-5.1.6-10.8 1.1-17.7 1.5L44 51zm60.1 21.3c-2.9 1.8-7.5 2.7-13.9 2.7H79.2l5.5-2.1c.2-.1.4-.2.6-.4.6-.5.9-1.4.5-2.2v-.1c0-.1-.1-.1-.1-.2-.1-.2-.3-.3-.4-.5-.5-.5-1.3-.6-2-.3L37.7 87H27.1l4-2.5L50 72.7c.9-.6 1.2-1.8.6-2.8-.6-.9-1.8-1.2-2.8-.6L38.9 75h-8.3l3.6-2.3c.9-.6 1.2-1.8.6-2.8-.1-.1-.1-.2-.2-.3-.6-.7-1.7-.8-2.5-.3L18.6 78H12l1.7-2.5 2.3-3.4c.3-.4.4-1 .3-1.5L10.7 44H16c3.1 5.5 9.5 16 14.1 16 6.1 0 11.4-.1 16.2-.4 4.5-.2 8.5-.5 12.2-.9 3.7-.3 7-.7 10.2-1.1 7.8-.9 14.5-1.6 23.2-1.6 2.9 0 5.7.7 8.5 1.8L92.6 59c-1.1.2-1.8 1.2-1.7 2.3.1 1 1 1.7 2 1.7h.3l13-2h.1c4.2 2.7 7.8 5.9 10.1 8.3.7.8 1.3 1.4 1.8 2 .1.2-.2.8-.5 1z",
    fill: "#221f1f",
    opacity: 1,
    "data-original": "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9 62c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2zM80.9 62c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2zM73 63c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2zM65 64c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2zM57 64c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2zM49.1 64c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2s.9-2 2-2h1c1.1 0 2 .9 2 2z",
    fill: "#221f1f",
    opacity: 1,
    "data-original": "#221f1f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateJets);
export default __webpack_public_path__ + "static/media/PrivateJets.0130def4d19824716758ec754e0978a8.svg";
export { ForwardRef as ReactComponent };